module.exports = __webpack_public_path__ + "img/download-black.3faf7ce9.svg";